import { render } from "./CarouselSolarPackages.vue?vue&type=template&id=fce033dc&scoped=true&ts=true"
import script from "./CarouselSolarPackages.vue?vue&type=script&lang=ts"
export * from "./CarouselSolarPackages.vue?vue&type=script&lang=ts"

import "./CarouselSolarPackages.vue?vue&type=style&index=0&id=fce033dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fce033dc"]])

export default __exports__